/**
 * 判断一个元素是否是 dumb element，例如 disabled 原生按钮组件，这些东西会被浏览器拦截一些事件，比如 mousemove 等等
 *
 * @param {any} node
 * @return {node is HTMLElement}
 */
export function isDumbElement(node) {
  if (!node || node.nodeType !== Node.ELEMENT_NODE) return false;
  return node.matches(':disabled, select, textarea, input, iframe, a');
}
//# sourceMappingURL=isDumbElement.js.map
